import { TranslateService } from "@ngx-translate/core";
import localeGb from '@angular/common/locales/en-GB';
import localeUs from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import localeNl from '@angular/common/locales/nl';
import localeSv from '@angular/common/locales/sv';
import localeNb from '@angular/common/locales/nb';
import { registerLocaleData } from '@angular/common';
import { customLocaleDa } from '../shared/locale/customLocales'
import { registeredLanguages } from "../models/state/profile/profile-state";
import { firstValueFrom } from "rxjs";

export function languageInitializerFactory(
  translate: TranslateService,
): () => Promise<void> {

  return async () => {

    translate.addLangs(registeredLanguages);
    
    // Register local date for angular date pipe
    registerLocaleData(customLocaleDa());
    registerLocaleData(localeGb);
    registerLocaleData(localeUs);
    registerLocaleData(localeDe);
    registerLocaleData(localeSv);
    registerLocaleData(localeNl);
    registerLocaleData(localeNb);
    registerLocaleData(localeIt);

    // Load the fallback language BEFORE bootstrap completes.
    //
    // Nothing else does: the profile effect only calls translate.use() once checkAuth has resolved
    // mid-bootstrap, so the first screens can paint with no i18n file loaded at all - and
    // EmptyMissingTranslationHandler turns every unresolved key into an empty string, not the key.
    // The login loading screen is the most visible victim: a blank status line under the spinner.
    //
    // App initializers run concurrently and Angular awaits them together, so this overlaps
    // checkAuth's round trips and costs effectively nothing. A failed fetch must not wedge the app,
    // so it degrades to the old behaviour rather than blocking bootstrap.
    try {
      await firstValueFrom(translate.use('en-GB'));
    } catch {
      // Untranslated UI is bad; an app that never boots is worse.
    }
  }

}
